export const MAX_SHOWN_LIMIT_TOPICS = 5;

export const topicApiUrl = {
	getTopicsList: 'topics',
	getTopicById: 'topics/:topicId',
};
